/**
 * Corus Currency Format Fix
 * Overrides the store's money format to always display AED instead of the
 * Arabic Dhs. symbol, and rewrites any already-rendered "Dhs." text.
 *
 * IMPORTANT: this used to attach a MutationObserver to document.body that
 * ran forever, on every DOM mutation, for the entire lifetime of the page.
 * That included every header open/close, every menu hover state change,
 * every cart drawer animation frame — anything that touches the DOM
 * anywhere on the page. It was fighting with the header component's own
 * state management and breaking its rendering. It has been replaced with:
 *   1. A single run on DOMContentLoaded (covers the initial page render).
 *   2. A listener on Shopify's own cart/variant update events (covers the
 *      only places prices actually re-render dynamically afterwards).
 *   3. A MutationObserver scoped ONLY to the cart drawer element (if present)
 *      — never document.body — since that is the one place content can be
 *      injected outside of a full page navigation.
 */
(function () {
  'use strict';

  if (window.Shopify) {
    window.Shopify.money_format = 'AED {{amount}}';
    window.Shopify.money_with_currency_format = 'AED {{amount}}';
  }

  function fixCurrencyInElement(el) {
    if (!el || !el.querySelectorAll) return;
    var nodes = el.querySelectorAll('.money, [data-price]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.textContent.indexOf('Dhs.') !== -1) {
        node.textContent = node.textContent.replace(/Dhs\.\s*/g, 'AED ');
      }
    }
  }

  function run() {
    fixCurrencyInElement(document.body);
  }

  if (document.readyState !== 'loading') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }

  // Re-run after the theme's own cart/variant update events, which is the
  // only time prices change without a full page navigation.
  document.addEventListener('cart:updated', run);
  document.addEventListener('variant:update', run);

  // Scoped observer: only watches the cart drawer (if the theme uses one),
  // never the whole document. This covers cart-drawer price re-renders
  // that don't dispatch a custom event.
  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawer = document.querySelector('cart-drawer-component, #cart-drawer, [id*="cart-drawer"]');
    if (cartDrawer && window.MutationObserver) {
      var observer = new MutationObserver(function () { fixCurrencyInElement(cartDrawer); });
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  });
})();
